/**
 * One React Query client for everything Sales Command Center touches.
 *
 * The live-call dock is mounted on the app shell so it survives navigation between
 * modules, while the SCC pages mount and unmount underneath it. They have to share a
 * cache: two clients would mean two polls of `/calls/open`, two session exchanges, and
 * a dock and a page that disagree about whether a call is running.
 */
import { QueryClient } from '@tanstack/react-query';

export const sccQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default sccQueryClient;
